import styled from 'styled-components';

import { BsDatabase } from 'react-icons/bs';
import { LiaSitemapSolid } from 'react-icons/lia';
import { MdKeyboardDoubleArrowLeft } from 'react-icons/md';
import { MdKeyboardDoubleArrowRight } from 'react-icons/md';
import { IoExtensionPuzzleOutline, IoPersonOutline } from 'react-icons/io5';

import { EditorLeftSideBarTab } from 'types';
import { editorLeftTabBarWidth } from 'styles/commonStyles';
import IconButton from 'components/ui/IconButton';
import TabButton from './components/TabButton';

const Container = styled.div`
  ${editorLeftTabBarWidth};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  height: 100%;
  border-right: 1px solid ${(props) => props.theme.global.borderColor};
  padding: 10px 0;
  gap: 10px;
`;

const MenuBtnView = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

interface TabBarProps {
  selectedTab: EditorLeftSideBarTab;
  isMenuHide: boolean;
  onMenuHideButtonClick: () => void;
  onTabClick: (newTab: EditorLeftSideBarTab) => void;
}

const TabBar = ({ selectedTab, isMenuHide, onMenuHideButtonClick, onTabClick }: TabBarProps) => {
  return (
    <Container>
      <MenuBtnView>
        <TabButton tab={'data'} tooltip="데이터" selectedTab={selectedTab} onTabClick={onTabClick} Icon={BsDatabase} />
        <TabButton
          tab={'layer'}
          tooltip="레이어"
          selectedTab={selectedTab}
          onTabClick={onTabClick}
          Icon={IoExtensionPuzzleOutline}
        />
        <TabButton
          tab={'model'}
          tooltip="모델"
          selectedTab={selectedTab}
          onTabClick={onTabClick}
          Icon={LiaSitemapSolid}
        />
        <TabButton
          tab={'custom'}
          tooltip="커스텀"
          selectedTab={selectedTab}
          onTabClick={onTabClick}
          Icon={IoPersonOutline}
        />
      </MenuBtnView>
      <IconButton $size={40} $iconSize={30} $hasRadius onClick={onMenuHideButtonClick}>
        {isMenuHide ? <MdKeyboardDoubleArrowRight /> : <MdKeyboardDoubleArrowLeft />}
      </IconButton>
    </Container>
  );
};

export default TabBar;
